import api from "./api";

// Memo singkat (60 detik) supaya permintaan yang sama tidak diulang dan bisa
// dijalankan lebih awal (paralel) oleh halaman yang akan memakainya.
// Tambahan PR46 (29/10/2026): jawaban yang sudah tiba bisa dibaca langsung (`simpanan`) supaya Katalog tampil tanpa jeda kosong, lalu
// diperbarui dari server di latar (`segarkan`). Hanya di memori (bukan localStorage); dibuang saat keluar/ganti akun (`kosongkan`).
const memo = new Map();
const UMUR = 60_000;
const kunciDari = (url, params) => url + (params && Object.keys(params).length ? JSON.stringify(params) : "");
const minta = (url, params) => api.get(url, params && Object.keys(params).length ? { params } : undefined).then(({ data }) => data);

// Generasi memo: naik saat dikosongkan, supaya jawaban permintaan lama (mis. sebelum keluar) tidak masuk lagi
let generasi = 0;

function catat(kunci, p, lama) {
  const g = generasi;
  const e = { waktu: Date.now(), p, ada: lama ? lama.ada : false, data: lama ? lama.data : undefined, tiba: lama ? lama.tiba : 0 };
  memo.set(kunci, e);
  p.then((data) => {
    if (g !== generasi || memo.get(kunci) !== e) return;
    e.ada = true; e.data = data; e.tiba = Date.now();
  }, () => {
    if (g !== generasi || memo.get(kunci) !== e) return;
    if (e.ada) e.p = Promise.resolve(e.data);   // gagal memperbarui: simpanan lama tetap sampai umurnya habis
    else memo.delete(kunci);
  });
  return p;
}

export function ambil(url, params) {
  const kunci = kunciDari(url, params);
  const lama = memo.get(kunci);
  if (lama && Date.now() - lama.waktu < UMUR) return lama.p;
  return catat(kunci, minta(url, params), lama);
}

/** Jawaban yang sudah tiba dan berumur ≤ 60 detik, atau undefined. */
export function simpanan(url, params) {
  const e = memo.get(kunciDari(url, params));
  return e && e.ada && Date.now() - e.tiba < UMUR ? e.data : undefined;
}

/** Selalu minta baru ke server; hasilnya disimpan (simpanan lama tetap terbaca selama menunggu). */
export function segarkan(url, params) {
  const kunci = kunciDari(url, params);
  return catat(kunci, minta(url, params), memo.get(kunci));
}

/** Buang semua simpanan (keluar / ganti akun). */
export function kosongkan() {
  generasi += 1;
  memo.clear();
}
